import { render, staticRenderFns } from "./BrandingEdit.vue?vue&type=template&id=45e4ab18"
import script from "./BrandingEdit.vue?vue&type=script&lang=js"
export * from "./BrandingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports